import React from 'react';

import FilesExplorer from 'app/main/components/files-explorer/FilesExplorer';
import DetailsSectionWrapper from '../components/DetailsSectionWrapper';

interface DetailsSectionFilesProps {
	className?: string;
	icon?: React.ReactNode;
	title?: React.ReactNode;
	subheader?: React.ReactNode;
	folderPath: string;
	disableUpload?: boolean;
	disableDelete?: boolean;
	hidePath?: boolean;
}

export default function DetailsSectionFiles({
	className,
	icon,
	title,
	subheader,
	folderPath,
	disableUpload,
	disableDelete,
	hidePath
}: DetailsSectionFilesProps) {
	return (
		<DetailsSectionWrapper className={className} avatar={icon} title={title} subheader={subheader} disablePadding>
			<FilesExplorer
				folderPath={folderPath}
				disableUpload={disableUpload}
				disableDelete={disableDelete}
				hidePath={hidePath}
			/>
		</DetailsSectionWrapper>
	);
}
